import { InternalApprovalHistoryController } from './internal-approval-history.controller'

function internalApprovalHistoryDirective () {
  return {
    restrict: 'E',
    scope: {
      task: '<'
    },
    templateUrl: '/workflow/directives/internal-approval-history/internal-approval-history-directive.html?$$REVISION$$',
    controller: InternalApprovalHistoryController
  }
}

export { internalApprovalHistoryDirective }
